import { z } from 'zod';
import { contactSortSchema } from './contacts.js';
import { segmentDefinitionSchema } from './segments.js';
/**
 * The contacts board's saved views.
 *
 * **A view is not a segment.** A view says what somebody is looking at — which
 * rows, in what order, with which columns showing. A segment says who a
 * campaign reaches, and has members as well as rules. They were the same thing
 * here, which meant saving a way of looking at the board created an audience.
 * Segments are made on the Segments screen.
 *
 * `definition` is the same rule shape a segment stores, because "who matches
 * these rules" is one question and must have one answer. That is the whole of
 * what the two share.
 */
export const saveContactViewRequestSchema = z.object({
    name: z.string().trim().min(1, 'a view needs a name').max(120),
    definition: segmentDefinitionSchema,
    /** Absent is the board's own order, which is newest first. */
    sort: contactSortSchema.optional(),
    /** Column ids this view hides. Empty is every column showing. */
    hidden: z.array(z.string().max(80)).max(200).default([]),
});
export const contactViewDetailSchema = z.object({
    viewId: z.string(),
    name: z.string(),
    definition: segmentDefinitionSchema,
    sort: contactSortSchema.nullable(),
    hidden: z.array(z.string()),
});
export const contactViewListSchema = z.object({ views: z.array(contactViewDetailSchema) });
/**
 * Saving answers one of two ways, and the form acts on each.
 *
 * `name-taken` is an answer rather than a failed request: two tabs called
 * "Active" is a strip nobody can use, and retyping a name you already used is
 * an ordinary mistake to be told about rather than an error.
 */
export const saveContactViewResponseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('saved'), viewId: z.string() }),
    z.object({ status: z.literal('name-taken') }),
]);
//# sourceMappingURL=contactViews.js.map